import { render } from "@/components/pages/individualDtcVch/IndividualDtcVch.html?vue&type=template&id=11fdfdb5&external"
import script from "@/components/pages/individualDtcVch/IndividualDtcVch.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualDtcVch/IndividualDtcVch.js?vue&type=script&lang=js&external"

import "@/components/pages/individualDtcVch/IndividualDtcVch.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__